import { useState } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import SwiperCore, { Navigation, Keyboard, Mousewheel, Thumbs, Controller } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Icon } from '@moneymade/moneymade-ui'

import { toAutoPlayVideoUrl } from 'modules/discover/discoverUtils'
import ImgLazy from 'components/ui/ImgLazy/ImgLazy'
import { getCdnImg } from 'utils/getters'
import styles from './HighlightsSlider.module.scss'

// Install Swiper components
SwiperCore.use([Navigation, Keyboard, Mousewheel, Thumbs, Controller])

const HighlightsSlider = ({ videosData: { videos, videosTumbs }, medias }) => {
  // Store thumbs swiper instance
  const [thumbsSwiper, setThumbsSwiper] = useState(null)
  // Store modal swiper instance
  const [modalSwiper, setModalSwiper] = useState(null)
  const [isModal, setModal] = useState(false)

  return (
    <>
      {thumbsSwiper &&
        createPortal(
          <div className={`${styles.HighlightsSliderModal} ${isModal ? styles.Active : ''}`}>
            <div className={styles.Overlay} onClick={() => setModal(false)} aria-hidden />

            <Swiper
              slidesPerView={1}
              spaceBetween={10}
              className={styles.SliderModal}
              onSwiper={setModalSwiper}
              navigation={{
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next'
              }}
              allowTouchMove={false}
            >
              <>
                {videos.map((url, index) => (
                  <SwiperSlide key={index} className={styles.IframeWrapper}>
                    {({ isActive }) =>
                      isModal ? (
                        <iframe
                          loading="lazy"
                          title="PreviewIframe"
                          frameBorder="0"
                          allow="fullscreen"
                          width="100%"
                          src={isActive ? toAutoPlayVideoUrl(url) : url}
                          className={styles.Iframe}
                        />
                      ) : null
                    }
                  </SwiperSlide>
                ))}

                {medias.map((url, index) => (
                  <SwiperSlide key={index} className={styles.ImageWrapper}>
                    <ImgLazy
                      src={getCdnImg(url, 1000)}
                      alt="attachment"
                      className={styles.Image}
                      width="100%"
                      height="100%"
                    />
                  </SwiperSlide>
                ))}
              </>
            </Swiper>

            <button type="button" className={styles.XMark} onClick={() => setModal(false)}>
              <Icon icon="icon-x-mark" size={16} />
            </button>

            <button type="button" className="swiper-button-prev">
              <i className="icon-point-left" />
            </button>
            <button type="button" className="swiper-button-next">
              <i className="icon-point-right" />
            </button>
          </div>,
          document.body
        )}

      <div className={styles.HighlightsSlider}>
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          thumbs={{ swiper: thumbsSwiper }}
          controller={{ control: modalSwiper }}
          className={styles.Slider}
          mousewheel={{ forceToAxis: true }}
          keyboard
          cssMode
        >
          <>
            {videos.map((url, index) => (
              <SwiperSlide key={index}>
                {() => (
                  <div className={styles.IframeWrapper}>
                    <iframe
                      loading="lazy"
                      title="PreviewIframe"
                      frameBorder="0"
                      allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      width="100%"
                      src={url}
                      scrolling="no"
                      className={styles.Iframe}
                    />
                  </div>
                )}
              </SwiperSlide>
            ))}

            {medias.map((url, index) => (
              <SwiperSlide key={index} className={styles.ImageWrapper}>
                <button type="button" onClick={() => setModal(true)}>
                  <ImgLazy
                    src={getCdnImg(url, 588)}
                    alt="attachment"
                    className={styles.Image}
                    width="100%"
                    height="100%"
                  />
                </button>
              </SwiperSlide>
            ))}
          </>
        </Swiper>

        <div className={styles.Thumbs}>
          <Swiper
            slidesPerView={5}
            spaceBetween={13}
            onSwiper={setThumbsSwiper}
            breakpoints={{
              960: {
                slidesPerView: 5
              },
              600: {
                slidesPerView: 4
              },
              0: {
                slidesPerView: 3
              }
            }}
            navigation
            modules={[Navigation]}
          >
            <>
              {videosTumbs?.map((thumb, index) => (
                <SwiperSlide key={index} className={`${styles.ThumbWrapper} ${styles.VideoThumbWrapper}`}>
                  <button type="button">
                    <span className={styles.VideoPreview}>
                      <ImgLazy src={thumb} alt="preview" className={styles.Thumbnail} />
                      <Icon icon="icon-play" size={15} />
                    </span>
                  </button>
                </SwiperSlide>
              ))}

              {medias?.map((url, index) => (
                <SwiperSlide key={index} className={styles.ThumbWrapper}>
                  <button type="button">
                    <ImgLazy src={url} alt="thumb" className={styles.Thumbnail} />
                  </button>
                </SwiperSlide>
              ))}
            </>
          </Swiper>
        </div>
      </div>
    </>
  )
}

HighlightsSlider.propTypes = {
  videosData: PropTypes.shape({
    videos: PropTypes.array,
    videosTumbs: PropTypes.array
  }),
  medias: PropTypes.array
}

HighlightsSlider.defaultProps = {
  videosData: {
    videos: [],
    videosTumbs: []
  },
  medias: []
}

export default HighlightsSlider
